import { render, staticRenderFns } from "./delete-client-modal.vue?vue&type=template&id=fcc1931a"
import script from "./delete-client-modal.vue?vue&type=script&lang=js"
export * from "./delete-client-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports